import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    storageKey: { type: String, default: 'art_utm_params' },
    expireDays: { type: Number, default: 30 }
  }

  static utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  connect() {
    this.captureUtmParams();
  }

  captureUtmParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmData = {};

    this.constructor.utmParams.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        utmData[param] = value;
      }
    });

    // Only store if we have UTM parameters
    if (Object.keys(utmData).length > 0) {
      this.setStorage(utmData);
      console.log('UTM parameters captured:', utmData);
    }
  }

  setStorage(data) {
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + this.expireDaysValue);

    const storageData = {
      utm: data,
      expires: expiryDate.getTime()
    };

    localStorage.setItem(this.storageKeyValue, JSON.stringify(storageData));
    console.log('UTM parameters stored in localStorage');
  }

  // Static method to get UTM params (can be called from other controllers)
  static getUtmParams() {
    const storageKey = 'art_utm_params';

    try {
      const stored = localStorage.getItem(storageKey);
      if (!stored) return {};

      const data = JSON.parse(stored);

      // Check if expired
      if (data.expires && Date.now() > data.expires) {
        localStorage.removeItem(storageKey);
        return {};
      }

      return data.utm || {};
    } catch (error) {
      console.error('Error reading UTM params from localStorage:', error);
      return {};
    }
  }

  // Clear UTM params
  clearUtmParams() {
    localStorage.removeItem(this.storageKeyValue);
  }
}

// utm_source=120233438016940746
// utm_medium=fb
// utm_campaign=New+State+Campaign
// utm_content=120236180804470746
// fbclid=IwZXh0bgNhZW0BMABhZGlkAasqeNwLJ3pzcnRjBmFwcF9pZAwzNTA2ODU1MzE3MjgAAR4prTbz63RQbvgC2VGWMwp3tkKZH7Hr277imFBudP04_OO-kNFg6io5u7HkHA_aem_PqQL3uenX-wL9cgT33sM_g
// campaign_id=120233438016940746
// ad_id=120236191783050746
// utm_id=120233438016940746
// utm_term=120236180804480746
